
/**
 * This allows vintage substitutions to be removed from the cart
 */
document.addEventListener('click', async (evt) => {
    const target = evt.target.closest('.remove-allow-substitutions');

    if(target) {

        const cartItem = target.closest('.cart-item');
        const variant_properties = cartItem.getAttribute('data-variant-properties');

        const matchingCartItems = (JSON.parse(variant_properties).length > 1) ?
            document.querySelectorAll(`[data-variant-properties='${variant_properties}']`) :
            [cartItem];

        const formData = Array.from(matchingCartItems).map((item) => {
            const properties = Object.fromEntries(JSON.parse(item.getAttribute('data-variant-properties')));
            const key = item.getAttribute('data-variant-key')
            return {
                id: key,
                properties: {
                    ...properties,
                    'Allow vintage substitutions': 'No'
                }
            }
        })

        const result = [];

        for (const data of formData) {
            const response = await changeProperties(data);
            result.push(response);
        }

        if(result.some((response) => response.success)) {
            const cartItems = document.querySelector('cart-items');
            cartItems.refresh();
        }else {
            console.error('Failed to remove vintage substitutions');
        }
        
    }
})

async function changeProperties(formData = {id: '', properties: {}}) {

    try {

        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
    
        const data = await response.json();
    
        if (!response.ok) throw new Error(data.errors || response.status);

        return {
            success: true,
            data: data
        }

    } catch (error) {
        console.error(error);
        return {
            success: false,
            error: error
        }
    }

}
